import { NavLink } from 'react-router-dom';

export default function NavChaptersList(props) {
	const defaultStyle = "py-1 pl-4 pr-6 block hover:bg-neutral-700 hover:underline ";

	return (
    <NavLink to={props.link} className={({isActive}) => isActive ? defaultStyle + "bg-neutral-800" : defaultStyle}>{props.text}</NavLink>
	)
}